// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PMobileOutlinedSvg from "@fishx/icons-svg/es/asn/PMobileOutlined";
import FishxIcon from '../components/FishxIcon';

var PMobileOutlined = function PMobileOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PMobileOutlinedSvg
  }));
};

PMobileOutlined.displayName = 'PMobileOutlined';
export default React.forwardRef(PMobileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PMobileOutlined.js
// module id = 3518
// module chunks = 0